// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NDLxYUZCyyn0Ry4Xl2fg {
  font-size: 0.9375rem;
  line-height: 1.5rem;
  color: var(--midnight-purple);
  padding: 0.5rem 1.75rem
}

.NDLxYUZCyyn0Ry4Xl2fg:hover {
    background: var(--grey-50);
  }

.C0pTPfqDHgNbbWIpR9vf {
  display: flex;
  align-items: center;
  justify-content: flex-start
}

.C0pTPfqDHgNbbWIpR9vf > *:first-child {
    margin-right: 0.75rem;
    max-width: 1rem;
    min-width: 1rem;
  }

.BcMXkUMVFeR86GXLlORg {
  background: var(--grey-50)
}

.BcMXkUMVFeR86GXLlORg:hover,
  .BcMXkUMVFeR86GXLlORg.ZGRZrJSqUuzfM3pQN2U7 {
    background: var(--grey-200);
  }

.ZGRZrJSqUuzfM3pQN2U7 {
  background: var(--grey-200);
}
`, "",{"version":3,"sources":["webpack://./src/components/SelectItem/SelectItem.module.css"],"names":[],"mappings":"AAAA;EACE,oBAAe;EACf,mBAAiB;EACjB,6BAA6B;EAC7B;AAKF;;AAHE;IACE,0BAA0B;EAC5B;;AAGF;EACE,aAAa;EACb,mBAAmB;EACnB;AAOF;;AALE;IACE,qBAAkB;IAClB,eAAe;IACf,eAAe;EACjB;;AAGF;EACE;AAMF;;AAJE;;IAEE,2BAA2B;EAC7B;;AAGF;EACE,2BAA2B;AAC7B","sourcesContent":[".selectItem {\n  font-size: 15px;\n  line-height: 24px;\n  color: var(--midnight-purple);\n  padding: 8px 28px;\n\n  &:hover {\n    background: var(--grey-50);\n  }\n}\n\n.selectItemWithIcon {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n\n  & > *:first-child {\n    margin-right: 12px;\n    max-width: 16px;\n    min-width: 16px;\n  }\n}\n\n.selectedItem {\n  background: var(--grey-50);\n\n  &:hover,\n  &.highlighted {\n    background: var(--grey-200);\n  }\n}\n\n.highlighted {\n  background: var(--grey-200);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"selectItem": `NDLxYUZCyyn0Ry4Xl2fg`,
	"selectItemWithIcon": `C0pTPfqDHgNbbWIpR9vf`,
	"selectedItem": `BcMXkUMVFeR86GXLlORg`,
	"highlighted": `ZGRZrJSqUuzfM3pQN2U7`
};
export default ___CSS_LOADER_EXPORT___;
